import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71eac43c&scoped=true&"
import script from "./miniCourse.ts?vue&type=script&lang=ts&"
export * from "./miniCourse.ts?vue&type=script&lang=ts&"
import style0 from "./miniCourse.css?vue&type=style&index=0&id=71eac43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eac43c",
  null
  
)

export default component.exports